import { Component, OnDestroy, OnInit } from '@angular/core'
import { select, Store } from '@ngrx/store'
import { JmlTitleService } from '../../../../services/jml-title.service'

import { combineLatest, Subscription } from 'rxjs'
import { filter, map, switchMap, withLatestFrom, tap } from 'rxjs/operators'
import { RootStoreState, UserProfileSelectors } from '../../../../root-store/root-index'
import { EntityAttachment, EntityConfiguration, EntityService } from '../../../dto'
import { EntityConfigService } from '../../../dto/services/entity-config.service'
import { AuthFacadeService } from '../../../../auth/services/auth-facade.service'

@Component({
  selector: 'jml-lib-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent implements OnInit, OnDestroy {
  layout: EntityAttachment[]
  dashboardId: number

  subscription: Subscription

  constructor(
    private store$: Store<RootStoreState.State>,
    private entityService: EntityService,
    private entityConfigService: EntityConfigService,
    private titleService: JmlTitleService,
    private authFacade: AuthFacadeService
  ) {}

  ngOnInit(): void {
    this.titleService.setAppTitle('Dashboard')

    const defaultDashboardHrid$ = this.store$.pipe(
      select((state) => UserProfileSelectors.selectDefaultDashboardHrid(state))
    )

    const dashboardConfig$ = this.entityConfigService.getConfig$('Dashboard').pipe(filter((config) => !!config))

    this.subscription = combineLatest([dashboardConfig$, defaultDashboardHrid$])
      .pipe(
        // prevent requests for dashboard with empty hrid
        filter(([config, defaultDashboardHrid]) => !!config && !!defaultDashboardHrid),
        withLatestFrom(this.authFacade.userIsLoggedIn$, this.authFacade.isInLogout$),
        // prevent requests for dashboard if user is not logged in
        filter(([, userIsLoggedIn, isInLogout]) => !!userIsLoggedIn && !isInLogout),
        map(([[config, defaultDashboardHrid], _, __]) => {
          const result: [EntityConfiguration, string] = [config, defaultDashboardHrid]
          return result
        }),
        switchMap(([config, defaultDashboardHrid]) =>
          this.entityService.getEntityByHrid(config.fields, 'Dashboard', defaultDashboardHrid)
        )
      )
      .subscribe((dashboard) => {
        this.dashboardId = dashboard.fields['id']
        this.layout = JSON.parse(dashboard.fields['layout'])
      })
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe()
  }
}
